<template>
  <div>
    <SfNotification
        :icon="{icon: icons.info.path, viewBox: icons.info.viewBox}"
        :message="notification.message"
        :type="notification.type"
        :visible="notification.isVisible"
        class="notification"
        @click:close="notification.isVisible = false"
    >
      <template #icon>
        <SfIcon :icon="icons.info.path" :view-box="icons.info.viewBox" class="icon" color="white"/>
      </template>
    </SfNotification>
    <form autocomplete="off" class="form" @submit.prevent="submitForm">
      <SfInput
          v-model="password"
          :error-message="password ? $t('accountForm.password.error') : $t('accountForm.password.required')"
          :has-show-password="true"
          :label="$t('myProfile.passwordUpdate.form.password')"
          :valid="passwordBlur || validPassword(password)"
          class="form__element"
          name="password"
          required
          type="password"
          @blur="passwordBlur = false"
      />
      <span class="passwordNotice">{{ $t('myProfile.passwordUpdate.tab.message') }}</span>
      <SfInput
          v-model="newPassword"
          :error-message="newPassword? $t('accountForm.newPassword.error') : $t('accountForm.newPassword.required')"
          :has-show-password="true"
          :label="$t('myProfile.passwordUpdate.form.newPassword')"
          :valid="newPasswordBlur || validPassword(newPassword)"
          class="form__element"
          name="newPassword"
          required
          type="password"
          @blur="newPasswordBlur = false"
      />
      <SfInput
          v-model="repeatPassword"
          :error-message="repeatPassword? $t('accountForm.repeatPassword.error') : $t('accountForm.repeatPassword.required')"
          :has-show-password="true"
          :label="$t('myProfile.passwordUpdate.form.repeatPassword')"
          :valid="repeatPasswordBlur || validRepeatPassword(repeatPassword)"
          class="form__element"
          name="repeatPassword"
          required
          type="password"
          @blur="repeatPasswordBlur = false"
      />
      <div v-if="error">
        <SfAlert :message="$t(error)" :visible="true"/>
      </div>
      <div class="form-action">
        <SfButton
            :disabled="loading"
            class="sf-button color-primary"
            type="submit"
        >
          <div v-if="loading">
            <SfLoader :class="{ loader: loading }"
                      :loading="loading"></SfLoader>
            {{ $t('Loading') }}
          </div>
          <div v-else> {{ $t('myProfile.passwordUpdate.form.button') }}</div>
        </SfButton>
      </div>
    </form>
  </div>
</template>

<script>

import {SfAlert, SfButton, SfInput, SfLoader, SfNotification, SfIcon} from '@storefront-ui/vue';
import Api from '@/api/Api';
import icons from "@/utils/icons";

export default {
  name: 'passwordChangeForm',
  components: {
    SfAlert,
    SfInput,
    SfButton,
    SfLoader,
    SfNotification,
    SfIcon
  },
  data() {
    return {
      loading: false,
      error: null,
      valid: false,
      submitted: false,
      password: null,
      passwordBlur: false,
      repeatPassword: null,
      repeatPasswordBlur: false,
      newPassword: null,
      newPasswordBlur: false,
      notification: {isVisible: false, message: "", type: "success"},
      icons: icons,
    }
  },
  methods: {
    validate() {
      this.passwordBlur = false;
      this.resetPasswordBlur = false;
      this.newPasswordBlur = false;

      return this.validPassword(this.password) && this.validRepeatPassword(this.repeatPassword) && this.validPassword(this.newPassword);
    },

    validPassword(password) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (password) {
        if (regex.test(password)) {
          return true
        } else {
          return false
        }
      }
      return true
    },

    validRepeatPassword(repeatPassword) {
      if (repeatPassword) {
        return this.newPassword === repeatPassword;
      }
      return true
    },

    submitForm() {
      const onComplete = () => this.loading = false;

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };

      if (this.validate()) {
        this.loading = true;
        Api.account.updatePassword({oldPassword: this.password, newPassword: this.newPassword}).then(
            () => {
              onComplete();
              this.notification = {
                isVisible: true,
                message: this.$i18n.t('myProfile.passwordUpdate.notifications.success'),
                type: 'success'
              }
            },
            err => {

              onError(err);
            }
        )
      }
    },
  }
}
</script>

<style lang='scss' scoped>
.notification {
  margin-bottom: 2rem;
}

.form-action {
  margin: var(--spacer-base) auto;
  display: flex;

  ::v-deep {
    .sf-button {
      margin: auto;
      flex: 0;
      white-space: nowrap;
      min-height: 52px;
    }
  }
}

::v-deep {
  .sf-icon {
    margin-right: 1rem;
  }
}
</style>